import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Box,
  Grid,
  FormControl,
  InputLabel,
  InputAdornment,
  OutlinedInput,
  Dialog,
  DialogTitle,
  Button,
  Snackbar,
  Alert,
  TextField,
  Avatar,
} from "@mui/material";
import React, { useEffect, useState, useContext } from "react";
import { appLogger, Http } from "../../utils";
import { UserContext } from "../../context/userContext";
import { UserLoginInfo } from "../../types/context";
import { getDateString, getDateTime } from "../../utils/data";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import DeleteDialog from "../../utils/common/DeleteDialog";
import {
  ROLE_USER_ADMIN,
  ROLE_USER_MANAGER,
  ROLE_USER_SUPERADMIN,
  UserInfo,
} from "../../model";
import {
  SORT_KEY_EMAIL,
  SORT_KEY_NAME,
  SORT_KEY_MODIFIED_ON,
  SORT_KEY_MODIFIED_BY,
} from "./constants";
import ProductVersionDropdown from "../common/ProductVersionDropdown";
import { getDateTimeRange } from "../../utils/data";
import ArticleQuesopenForm from "./ArticleQuesopenForm";
import ReplayIcon from "@mui/icons-material/Replay";

interface TablePaginationActionsProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement>,
    newPage: number
  ) => void;
}

function TablePaginationActions(props: TablePaginationActionsProps) {
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        <FirstPageIcon />
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        <LastPageIcon />
      </IconButton>
    </Box>
  );
}

const Manage = (props: any) => {
  const {
    ProVersion,
    setProVersion,
    filterDate,
    setFilterDate,
    contextProVersion,
    setcontextProVersion,
    contextRedirectProdPage,
    setContextMetricPageStartDate,
    setContextMetricPageEndDate,
    ContextMetricPageStartDate,
    ContextMetricPageEndDate,
  } = useContext(UserContext) as UserLoginInfo;
  const navigate = useNavigate();
  const [initialData, setInitialData] = React.useState([] as UserInfo[]);
  const [users, setUsers] = React.useState([] as UserInfo[]);
  const [searchUsers, setSearchUsers] = React.useState([] as any);
  const { userInfo } = useContext(UserContext) as UserLoginInfo;
  const [orderBy, setOrderBy] = useState(SORT_KEY_MODIFIED_ON);
  const [order, setOrder] = useState<"asc" | "desc">("desc");
  const [itemLimit, setItemLimit] = useState({
    lowerLimit: 0,
    upperLimit: 9,
  });
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [search, setSearch] = React.useState("");
  const [searchKeyword, setSearchKeyword] = React.useState("");
  const [isLoading, setIsloading] = React.useState(false);
  const [alertOpen, setAlertOpen] = React.useState(false);
  const [errorAlertOpen, setErrorAlertOpen] = React.useState(false);
  const [open, setOpen] = useState(false);
  const [deleteTxt, setDeleteTxt] = useState("");
  const [deleteEnable, setDeleteEnable] = useState(false);
  const [deleteID, setDeleteID] = useState([] as any);
  const [openResetPwDialog, setOpenResetPwDialog] = useState(false);
  const [focusEmailId, setFocusEmailId] = useState("");
  const [alertOpenResetPw, setAlertOpenResetPw] = React.useState(false);
  const [errorAlertOpenResetPw, setErrorAlertOpenResetPw] =
    React.useState(false);
  const [editID, setEditID] = useState({} as UserInfo);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [productResponse, setProductResponse] = React.useState([] as any);

  appLogger.info({
    infoObj: {
      method: "DashboardContent",
      component: "dashboard",
      fileName: "index.tsx",
      location: location,
    },
  });

  const currDate = new Date();
  const stDate = new Date(currDate);
  stDate.setHours(0, 0, 0, 0);
  currDate.setHours(23, 59, 59, 999);
  let stDateTimestamp: any = "";
  let currDateTimestamp: any = "";

  stDate.setMonth(currDate.getMonth() - 1);
  stDate.setDate(stDate.getDate() + 1);
  if (stDate && currDate) {
    stDateTimestamp = stDate.getTime();
    currDateTimestamp = currDate.getTime();
  }

  const [product, setProduct] = React.useState("");
  const [selectedProduct, setSelectedProduct] = React.useState<any>();
  const [version, setVersion] = React.useState("");
  // const [userData, setUserData] = React.useState([] as any);
  const [startDateValue, setStartDateValue] = React.useState(
    ContextMetricPageStartDate ? ContextMetricPageStartDate : stDateTimestamp
  );
  const [endDateValue, setEndDateValue] = React.useState(
    ContextMetricPageEndDate ? ContextMetricPageEndDate : currDateTimestamp
  );
  const [selectedProVerData, setselectedProVerData] = React.useState([] as any);
  const [proVerUrl, setproVerUrl] = React.useState("");
  const [reportsTicketsData, setReportsTicketsData] = React.useState([] as any);
  const [selectedProVerDataType, setselectedProVerDataType] =
    React.useState("confirm");
  const [MostReferedArticleData, setMostReferedArticleData] = React.useState(
    [] as any
  );

  useEffect(() => {
    setContextMetricPageStartDate(startDateValue);
    setContextMetricPageEndDate(endDateValue);
  }, [startDateValue, endDateValue]);

  useEffect(() => {
    if (selectedProVerDataType == "confirm" && selectedProVerData.length > 0) {
      fetchReportTicketsData();
    }
  }, [product, version, selectedProVerDataType]);

  useEffect(() => {
    if (product && version && proVerUrl) {
      if (
        (startDateValue && endDateValue) ||
        (startDateValue === null && endDateValue === null)
      ) {
        fetchReportTicketsData();
        setIsloading(true);
      }
    }
  }, [startDateValue, endDateValue]);

  // useEffect(() => {
  //   if (product && version && proVerUrl) {
  //     if (
  //       (startDateValue && endDateValue) ||
  //       (startDateValue === null && endDateValue === null)
  //     ) {
  //       fetchReportTicketsData();
  //       setIsloading(true);
  //     }
  //   }
  // }, [startDateValue, endDateValue]);

  useEffect(() => {
    setFilterDate({
      startDate: startDateValue,
      endDate: endDateValue,
    });
  }, [endDateValue]);

  useEffect(() => {
    appLogger.info({
      infoObj: {
        method: "useEffect",
        component: "dashboard",
        fileName: "index.tsx",
        filterDate: filterDate,
      },
    });
  }, [filterDate]);

  const changeStartDateValue = (e: any) => {
    const selectedDateString = e.target.value;
    const dt = new Date(selectedDateString);
    dt.setHours(0, 0, 0, 0);
    const timestamp = dt.getTime();
    setStartDateValue(timestamp);
    setContextMetricPageStartDate(timestamp);
    appLogger.info({
      infoObj: {
        method: "changeStartDateValue",
        component: "dashboard",
        fileName: "index.tsx",
        timestamp: timestamp,
      },
    });
    if (timestamp > endDateValue) {
      setEndDateValue(null);
      setContextMetricPageEndDate(null);
    }
  };
  const changeEndDateValue = (e: any) => {
    const selectedDateString = e.target.value;
    const dt = new Date(selectedDateString);
    dt.setHours(23, 59, 59, 999);
    const timestamp = dt.getTime();
    setEndDateValue(timestamp);
    setContextMetricPageEndDate(timestamp);

    appLogger.info({
      infoObj: {
        method: "changeEndDateValue",
        component: "dashboard",
        fileName: "index.tsx",
        timestamp: timestamp,
      },
    });
  };

  useEffect(() => {
    if (
      userInfo &&
      userInfo.idToken &&
      userInfo.idToken.length > 0 &&
      productResponse.length < 1
    ) {
      setIsloading(true);
      Http.get({
        url: `/api/v2/products/0`,
        state: userInfo,
      })
        .then((response: any) => {
          if (
            response &&
            response.productNameList &&
            response.productNameList.length > 0
          ) {
            response &&
              response.productNameList &&
              response.productNameList.length > 0 &&
              response.productNameList.sort((a: any, b: any) =>
                a.name.localeCompare(b.name)
              );
            appLogger.info({
              infoObj: {
                method: "useEffect",
                component: "dashboard",
                fileName: "index.tsx",
                productResponse: response,
              },
            });
            setProductResponse(response.productNameList);
            setProduct(ProVersion.product || response.productNameList[0].id);
            setVersion(
              ProVersion.version || response.productNameList[0].version
            );
            setSelectedProduct(response.productNameList[0]);

            setProVersion({
              product: ProVersion.product || response.productNameList[0].id,
              version:
                ProVersion.version || response.productNameList[0].version,
            });
            let tempurl = "";
            if (Array.isArray(contextProVersion)) {
              setcontextProVersion(contextProVersion);
              setselectedProVerData(contextProVersion);
              contextProVersion &&
                contextProVersion.length > 0 &&
                contextProVersion.map((data: any) => {
                  tempurl += `&prodId=${data.value}&prodVersion=${data.version}`;
                });
              setproVerUrl(tempurl);
            } else {
              setselectedProVerData([
                {
                  value: response.productNameList[0].id,
                  title: response.productNameList[0].name,
                  version: response.productNameList[0].version,
                },
              ]);
              setcontextProVersion([
                {
                  value: response.productNameList[0].id,
                  title: response.productNameList[0].name,
                  version: response.productNameList[0].version,
                  proversion:
                    response.productNameList[0].name +
                    response.productNameList[0].version,
                },
              ]);
              tempurl = `&prodId=${response.productNameList[0].id}&prodVersion=${response.productNameList[0].version}`;
              setproVerUrl(tempurl);
            }
            setIsloading(false);
          } else {
            appLogger.info({
              infoObj: {
                method: "useEffect",
                component: "dashboard",
                fileName: "index.tsx",
                userInfo: userInfo,
              },
            });
            setIsloading(false);
            if (
              !contextRedirectProdPage &&
              (userInfo?.userDetails?.userRole == ROLE_USER_SUPERADMIN ||
                userInfo?.userDetails?.userRole == ROLE_USER_MANAGER ||
                userInfo?.userDetails?.userRole == ROLE_USER_ADMIN)
            ) {
              // navigate("/products");
            }
            // props.snackbarShowMessage("No products created in your organization. Create a product first", "error");
            // setTimeout(() => {
            //   navigate("/add-product")
            // }, 2000);
          }
        })
        .catch((error) => {
          appLogger.error({
            errObj: {
              method: "useEffect",
              component: "dashboard",
              fileName: "index.tsx",
              err: error,
            },
          });
          props.snackbarShowMessage(error.message, "error");
          setIsloading(false);
        });
    }
  }, [userInfo]);

  const fetchReportTicketsData = async () => {
    if (proVerUrl) {
      const datewiseFilter = `&startDate=${
        startDateValue ? startDateValue : ""
      }&endDate=${endDateValue ? endDateValue : ""}`;
      const pageParams = `&page=${page}&limit=${rowsPerPage}`;
      // const response = await fetch(
      //   "https://api.slingacademy.com/v1/sample-data/users?offset=0&limit=5"
      //   // `https://api.slingacademy.com/v1/sample-data/users?${pageParams}`
      // );
      // const mostrefrddata = await response.json();
      setIsloading(true);
      // console.log(mostrefrddata, "mostrefrddata");
      Http.get({
        url: `/api/v2/chatbotmetrics/KBArticle?${proVerUrl}${datewiseFilter}${pageParams}`,
        state: userInfo,
      })
        .then((response: any) => {
          setIsloading(false);
          setMostReferedArticleData(response);
        })
        .catch((error) => {
          setIsloading(false);
          //props.snackbarShowMessage(error.message, "error");
          appLogger.error({
            errObj: {
              method: "fetchReportTicketsData",
              component: "cuvo-metrics-dashboard",
              fileName: "index.tsx",
              err: error,
            },
          });
        });
    }
  };

  const selectedProVerDataFn = (selectedProVerData: any, type: any) => {
    let getData = selectedProVerData;
    getData = selectedProVerData;
    setselectedProVerData(selectedProVerData);

    HandleContextSelectedProVer(getData);
    setselectedProVerData(getData);
    let tempproVerUrl = "";
    getData &&
      getData.length > 0 &&
      getData.map((data: any) => {
        tempproVerUrl += `&prodId=${data.value}&prodVersion=${data.version}`;
      });
    setproVerUrl(tempproVerUrl);
    setselectedProVerDataType(selectedProVerData.type);
  };
  const HandleContextSelectedProVer = (data: any) => {
    setcontextProVersion(data);
  };

  const clearDate = () => {
    setStartDateValue(stDateTimestamp);
    setEndDateValue(currDateTimestamp);
    setFilterDate({
      startDate: currDateTimestamp,
      endDate: currDateTimestamp,
    });
  };

  const minDateTime = new Date();
  minDateTime.setHours(17);
  const maxDateTime = new Date();
  maxDateTime.setHours(20);

  const hadleEditPopup = () => {
    setEditOpen(false);
  };

  const setDeleteHandle = (e: any) => {
    setDeleteTxt(e.target.value);
    setDeleteEnable(false);

    if (e.target.value.toLowerCase() == "delete") {
      setDeleteEnable(true);
    }
  };

  const clearInput = () => {
    setDeleteTxt("");
    setDeleteEnable(false);
  };

  const handleDeleteClose = () => {
    setDeleteOpen(false);
  };

  // const handleArticleQuesopen = (user: UserInfo) => {
  //   setEditOpen(true);
  // };

  useEffect(() => {}, [deleteID]);

  useEffect(() => {
    fetchReportTicketsData();
  }, [page, rowsPerPage]);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    if (event.target.value === "-1") {
      setItemLimit({
        lowerLimit: 0,
        upperLimit: users.length - 1,
      });
    } else {
      setItemLimit({
        lowerLimit: 0,
        upperLimit: parseInt(event.target.value, 10) - 1,
      });
    }
  };

  const handleRequestSort = (property: string) => {
    if (orderBy === property) {
      setOrder(order === "asc" ? "desc" : "asc");
    } else {
      setOrder("asc");
      setOrderBy(property);
    }
  };

  useEffect(() => {
    setUsers(users);
  }, [alertOpen, errorAlertOpen]);

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const handleErrorAlertClose = () => {
    setErrorAlertOpen(false);
  };

  const deleteUser = () => {
    setIsloading(true);
    Http.deleteReq({
      url: `/api/v2/users/${deleteID.id}`,
      state: userInfo,
    })
      .then((response: any) => {
        appLogger.info({
          infoObj: {
            method: "deleteUser",
            component: "users",
            fileName: "manage.tsx",
            deleteUserResponse: response,
          },
        });
        setDeleteOpen(false);
        setIsloading(false);
        setAlertOpen(true);
        setUsers(users.filter((e: any) => e.id != deleteID.id));
      })
      .catch((error) => {
        appLogger.error({
          errObj: {
            method: "deleteUser",
            component: "users",
            fileName: "manage.tsx",
            err: error,
          },
        });
        setIsloading(false);
        setErrorAlertOpen(true);
      });
  };

  function compareEmailId(a: UserInfo, b: UserInfo) {
    return a.emailId.localeCompare(b.emailId);
  }

  function compareEmailIdDesc(a: any, b: any) {
    return b.emailId.localeCompare(a.emailId);
  }

  function compareFirstName(a: UserInfo, b: UserInfo) {
    return a.nameFirst.localeCompare(b.nameFirst);
  }

  function compareFirstNameDesc(a: UserInfo, b: UserInfo) {
    return b.nameFirst.localeCompare(a.nameFirst);
  }

  function compareModifiedBy(a: UserInfo, b: UserInfo) {
    if (!b.lastModifiedBy && !a.lastModifiedBy) {
      return 0;
    }
    if (!b.lastModifiedBy) {
      return 1;
    }
    if (!a.lastModifiedBy) {
      return -1;
    }
    return a.lastModifiedBy.localeCompare(b.lastModifiedBy);
  }

  function compareModifiedByDesc(a: UserInfo, b: UserInfo) {
    if (!b.lastModifiedBy && !a.lastModifiedBy) {
      return 0;
    }
    if (!b.lastModifiedBy) {
      return -1;
    }
    if (!a.lastModifiedBy) {
      return 1;
    }
    return b.lastModifiedBy.localeCompare(a.lastModifiedBy);
  }

  function compareModifiedOn(a: UserInfo, b: UserInfo) {
    if (!b.lastModifiedOn && !a.lastModifiedOn) {
      return 0;
    }
    if (!b.lastModifiedOn) {
      return 1;
    }
    if (!a.lastModifiedOn) {
      return -1;
    }
    return b.lastModifiedOn > a.lastModifiedOn ? -1 : 1;
  }

  function compareModifiedOnDesc(a: UserInfo, b: UserInfo) {
    if (!b.lastModifiedOn && !a.lastModifiedOn) {
      return 0;
    }
    if (!b.lastModifiedOn) {
      return -1;
    }
    if (!a.lastModifiedOn) {
      return 1;
    }
    return b.lastModifiedOn > a.lastModifiedOn ? 1 : -1;
  }

  const sortFunction = (list: UserInfo[]) => {
    if (list.length > 0) {
      const tempSortedUsers = [...list];
      let sortedList: UserInfo[] = [];
      if (order === "asc") {
        if (orderBy === SORT_KEY_EMAIL) {
          sortedList = tempSortedUsers.sort(compareEmailId);
        } else if (orderBy === SORT_KEY_NAME) {
          sortedList = tempSortedUsers.sort(compareFirstName);
        } else if (orderBy === SORT_KEY_MODIFIED_ON) {
          sortedList = tempSortedUsers.sort(compareModifiedOn);
        } else if (orderBy === SORT_KEY_MODIFIED_BY) {
          sortedList = tempSortedUsers.sort(compareModifiedBy);
        }
      }
      if (order === "desc") {
        if (orderBy === SORT_KEY_EMAIL) {
          sortedList = tempSortedUsers.sort(compareEmailIdDesc);
        } else if (orderBy === SORT_KEY_NAME) {
          sortedList = tempSortedUsers.sort(compareFirstNameDesc);
        } else if (orderBy === SORT_KEY_MODIFIED_ON) {
          sortedList = tempSortedUsers.sort(compareModifiedOnDesc);
        } else if (orderBy === SORT_KEY_MODIFIED_BY) {
          sortedList = tempSortedUsers.sort(compareModifiedByDesc);
        }
      }
      setUsers(sortedList);
      return sortedList;
    }
  };

  useEffect(() => {
    sortFunction(users);
  }, [order, orderBy]);

  const handleKeyPress = (e: any) => {
    if (e.key === "Enter") {
      setSearchKeyword(search);
      e.preventDefault();
    }
  };

  const handleSearchTyping = (e: any) => {
    setSearch(e.target.value);
    if (e.target.value !== "") {
      const temp = searchUsers;
      const filteredRows = temp.filter((row: UserInfo) => {
        return row.nameFirst
          .toLowerCase()
          .includes(e.target.value.toLowerCase());
      });
      setUsers(filteredRows);
    } else {
      setUsers(searchUsers);
    }
  };

  const searchClear = () => {
    setSearch("");
    setUsers(searchUsers);
  };

  const handleCloseResetPwDialog = () => {
    setOpenResetPwDialog(false);
  };

  const resetPassword = () => {
    setIsloading(true);
    const body = {
      emailId: focusEmailId,
    };
    Http.post({
      url: `/api/v2/users/reset-password`,
      state: userInfo,
      body,
    })
      .then((response: any) => {
        setAlertOpenResetPw(true);
        setOpenResetPwDialog(false);
        setIsloading(false);
        setFocusEmailId("");
      })
      .catch((error) => {
        appLogger.error({
          errObj: {
            method: "resetPassword",
            component: "users",
            fileName: "manage.tsx",
            err: error,
          },
        });
        setIsloading(false);
        setErrorAlertOpenResetPw(true);
      });
  };

  const handleAlertCloseResetPw = () => {
    setAlertOpenResetPw(false);
  };

  const handleErrorAlertCloseResetPw = () => {
    setErrorAlertOpenResetPw(false);
  };

  const handleClosePopup = () => {
    props.setClosePopup();
    setEditOpen(false);
  };
  const handleRedirectTickets = (topic: any) => {
    const stateObj = {
      pageType: "listTopicPage",
      topic: topic,
    };
    navigate(`/view-tickets/${topic}`, { state: stateObj });

    // navigate("/view-tickets", { state: stateObj });
  };

  const renderStatusCount = (data: any, type: any) => {
    let count = 0;

    if (data && data.statusCounts && data.statusCounts.length > 0) {
      const resp = data.statusCounts.filter((e: any) => e.status == type);
      if (resp && resp.length > 0) {
        count = resp[0].ticketCount;
      }
      return count;
    }
  };
  const handleArticleQuesopen = () => {
    setEditOpen(true);
  };

  const convertToDate = (data: any) => {
    const date = new Date(data);
    // Extract the components of the date (month, day, year)
    const month = date.getMonth() + 1; // Months are zero-based, so add 1
    const day = date.getDate();
    const year = date.getFullYear();
    // Format the date as mm-dd-yyyy
    return day + "-" + month + "-" + year;
  };
  const renderArticleName = (articleName: any) => {
    if (articleName == "") return "-";

    const pattern1 =
      /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
    const str1 = articleName.replace(
      pattern1,
      "<a style='color:#1b66e6;word-wrap: break-word;white-space: normal' target='_blank' href='$1'>$1</a>"
    );
    const pattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
    const str2 = str1.replace(
      pattern2,
      '$1<a style="color:#1b66e6;word-wrap: break-word;white-space: normal"  target="_blank" href="https://$2">https://$2</a>'
    );
    let htmlData = str2;
    const inputString = str2.toString();
    if (isHTMLTag(inputString)) {
      htmlData = str2;
    } else {
      htmlData = str2 + " (You cannot download this file)";
    }

    return (
      <div
        style={{ color: "cadetblue" }}
        dangerouslySetInnerHTML={{
          __html: htmlData,
        }}
      ></div>
    );
  };
  function isHTMLTag(str: any) {
    try {
      const doc = new DOMParser().parseFromString(
        `<body>${str}</body>`,
        "text/html"
      );
      const firstChild = doc.body.firstChild;
      return firstChild !== null && firstChild.nodeType === 1; // Node.ELEMENT_NODE
    } catch (error) {
      return false;
    }
  }
  return (
    <Box sx={{ p: 1 }}>
      <Grid
        className="feedback-bug-filter"
        container
        spacing={1}
        sx={{ mb: 2 }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={4}
          xl={4}
          className="pro-ver-dropdown-grid"
        >
          <ProductVersionDropdown
            productResponse={productResponse}
            selectedProVerData={selectedProVerData}
            selectedProVerDataFn={selectedProVerDataFn}
            contextProVersion={contextProVersion}
            type="cuvo-topics"
          />
        </Grid>
        <Grid item xs={6} sm={4} md={3} lg={1.5} sx={{ ml: "auto" }}>
          <Box>
            <TextField
              className="date-picker custom-select"
              id="datetime-local-start"
              label="Start Date"
              type="date"
              value={startDateValue ? getDateString(startDateValue) : ""}
              onChange={(newValue: any) => {
                changeStartDateValue(newValue);
              }}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                step: 1,
                max: currDate.toISOString().slice(0, 10),
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={6} sm={4} md={3} lg={1.5}>
          <Box>
            <TextField
              className="date-picker custom-select"
              id="datetime-local-end"
              label="End Date"
              value={endDateValue ? getDateString(endDateValue) : ""}
              onChange={(newValue: any) => {
                changeEndDateValue(newValue);
              }}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                step: 1,
                min: getDateString(startDateValue),
                max: currDate.toISOString().slice(0, 10),
              }}
              type="date"
            />
          </Box>
        </Grid>
        {startDateValue || endDateValue ? (
          <Grid item className="clear-option" title="Clear">
            <ReplayIcon onClick={clearDate} />
          </Grid>
        ) : (
          <ReplayIcon />
        )}
      </Grid>
      <Grid className="manage-search" container spacing={2}>
        <Grid item xs={12} md={4} lg={2} sx={{ mb: 1 }}>
          <FormControl className="custom-select" fullWidth>
            <InputLabel>Search</InputLabel>
            <OutlinedInput
              type="text"
              value={search}
              onChange={handleSearchTyping}
              onKeyPress={handleKeyPress}
              id="search-input"
              endAdornment={
                <>
                  {search && (
                    <InputAdornment position="end" onClick={searchClear}>
                      <IconButton
                        aria-label="search icon"
                        edge="end"
                        className="search-fb-icon"
                      >
                        <CloseIcon className="cursor-pointer" />
                      </IconButton>
                    </InputAdornment>
                  )}
                  <InputAdornment position="end">
                    <IconButton aria-label="search icon" edge="end">
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                </>
              }
              label="Search"
            />
          </FormControl>
        </Grid>
      </Grid>
      <Box className="table-wrap">
        <Table className={isLoading ? "table loader" : "table"}>
          <TableHead>
            <TableRow
              sx={{ background: "#DBDCE0" }}
              style={{ whiteSpace: "normal", wordWrap: "break-word" }}
            >
              <TableCell>
                {/* <TableSortLabel
                  active={orderBy === SORT_KEY_NAME}
                  direction={orderBy === SORT_KEY_NAME ? order : "asc"}
                  onClick={() => {
                    handleRequestSort(SORT_KEY_NAME);
                  }}
                  hideSortIcon={false}
                > */}
                <Typography>Article Name / URL</Typography>
                {/* <span
                    className={
                      orderBy === SORT_KEY_NAME
                        ? `custom-sort-icon active ${order}`
                        : "custom-sort-icon"
                    }
                  >
                    <ArrowUpwardIcon />
                    <ArrowDownwardIcon />
                  </span> */}
                {/* </TableSortLabel> */}
              </TableCell>
              <TableCell align="center">
                {/* <TableSortLabel
                  active={orderBy === SORT_KEY_EMAIL}
                  direction={orderBy === SORT_KEY_EMAIL ? order : "asc"}
                  onClick={() => {
                    handleRequestSort(SORT_KEY_EMAIL);
                  }}
                  hideSortIcon={false}
                > */}
                <Typography>Number of times referred</Typography>
                {/* <span
                    className={
                      orderBy === SORT_KEY_EMAIL
                        ? `custom-sort-icon active ${order}`
                        : "custom-sort-icon"
                    }
                  >
                    <ArrowUpwardIcon />
                    <ArrowDownwardIcon />
                  </span> */}
                {/* </TableSortLabel> */}
              </TableCell>
              {/* <TableCell>
                <TableSortLabel
                  active={orderBy === SORT_KEY_EMAIL}
                  direction={orderBy === SORT_KEY_EMAIL ? order : "asc"}
                  onClick={() => {
                    handleRequestSort(SORT_KEY_EMAIL);
                  }}
                  hideSortIcon={false}
                >
                  <Typography>Number of Successfull Referred</Typography>
                  <span
                    className={
                      orderBy === SORT_KEY_EMAIL
                        ? `custom-sort-icon active ${order}`
                        : "custom-sort-icon"
                    }
                  >
                    <ArrowUpwardIcon />
                    <ArrowDownwardIcon />
                  </span>
                </TableSortLabel>
              </TableCell> */}
              {/* <TableCell>
                <TableSortLabel
                  active={orderBy === SORT_KEY_EMAIL}
                  direction={orderBy === SORT_KEY_EMAIL ? order : "asc"}
                  onClick={() => {
                    handleRequestSort(SORT_KEY_EMAIL);
                  }}
                  hideSortIcon={false}
                >
                  <Typography>Number of Unsuccessfull Referred</Typography>
                  <span
                    className={
                      orderBy === SORT_KEY_EMAIL
                        ? `custom-sort-icon active ${order}`
                        : "custom-sort-icon"
                    }
                  >
                    <ArrowUpwardIcon />
                    <ArrowDownwardIcon />
                  </span>
                </TableSortLabel>
              </TableCell> */}
              {/* <TableCell>
                <TableSortLabel
                  active={orderBy === SORT_KEY_EMAIL}
                  direction={orderBy === SORT_KEY_EMAIL ? order : "asc"}
                  onClick={() => {
                    handleRequestSort(SORT_KEY_EMAIL);
                  }}
                  hideSortIcon={false}
                >
                  <Typography>Action</Typography>
                  <span
                    className={
                      orderBy === SORT_KEY_EMAIL
                        ? `custom-sort-icon active ${order}`
                        : "custom-sort-icon"
                    }
                  >
                    <ArrowUpwardIcon />
                    <ArrowDownwardIcon />
                  </span>
                </TableSortLabel>
              </TableCell> */}

              {/* <TableCell>
                  <TableSortLabel
                    active={orderBy === SORT_KEY_MODIFIED_BY}
                    direction={orderBy === SORT_KEY_MODIFIED_BY ? order : "asc"}
                    onClick={() => {
                      handleRequestSort(SORT_KEY_MODIFIED_BY);
                    }}
                    hideSortIcon={false}
                    IconComponent={SwapVertIcon}
                  >
                    <Typography style={{fontWeight: '700', color: '#000'}}>Modified By</Typography>
                  </TableSortLabel>
                </TableCell> */}
            </TableRow>
          </TableHead>

          <TableBody>
            {MostReferedArticleData &&
              MostReferedArticleData.kbArticles &&
              MostReferedArticleData.kbArticles.map((row: any, i: any) => (
                <TableRow
                  key={i}
                  style={{
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                  }}
                >
                  <TableCell
                    style={{
                      width: "600px",
                      whiteSpace: "normal",
                      wordWrap: "break-word",
                    }}
                  >
                    <Typography
                      style={{
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                      }}
                      sx={{
                        textTransform: "capitalize",
                        fontWeight: 500,
                        fontSize: "0.8rem",
                      }}
                    >
                      {/* {convertToTopic(row?.articles[0]?.article_name || "-")} */}
                      {row?.articles[0]?.article_title || "-"}
                    </Typography>

                    <Typography
                      style={{
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                      }}
                      sx={{
                        color: "rgba(0, 0, 0, 0.5)",
                        fontWeight: 400,
                        fontSize: "0.8rem",
                      }}
                    >
                      {/* <a
                        style={{
                          whiteSpace: "normal",
                          wordWrap: "break-word",
                        }}
                        target="_blank"
                        href={row?.articles[0]?.article_name || "-"}
                      >
                        {row?.articles[0]?.article_name || "-"}
                      </a> */}
                      {renderArticleName(row?.articles[0]?.article_name || "")}
                    </Typography>
                    <Typography
                      sx={{
                        color: "rgba(0, 0, 0, 0.5) !important",
                        fontWeight: 400,
                        fontSize: "0.8rem",
                      }}
                    >
                      Last updated date:&nbsp;{" "}
                      {convertToDate(
                        row?.articles[0]?.last_updated_date || "-"
                      )}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Avatar
                      sx={{
                        fontSize: "11px",
                        background: "#2858D3",
                        display: "inline-flex",
                        border: "1px solid #FFF",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#fff !important",
                          fontWeight: 700,
                          fontSize: "14px",
                        }}
                      >
                        {row.count}
                      </Typography>
                    </Avatar>
                  </TableCell>
                </TableRow>
              ))}
            {/* {emptyRows > 0 && (
              <TableRow style={{ height: 53 * emptyRows }}>
                <TableCell colSpan={6} />
              </TableRow>
            )} */}
          </TableBody>

          <TableBody sx={{ display: "none" }}>
            {(rowsPerPage > 0
              ? reportsTicketsData.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
              : reportsTicketsData
            ).map((topic: any, index: number) => {
              if (index < itemLimit.lowerLimit) {
                return;
              }
              if (index > itemLimit.upperLimit) {
                return;
              }

              return (
                <TableRow key={index}>
                  <TableCell>
                    {/* {topic.profilePic && (
                      <img className="prod-logo" src={user.profilePic} />
                    )} */}

                    {/* {!user.profilePic && (
                      <Typography className="prod-logo-txt">
                        {user.nameFirst[0].toUpperCase()}
                      </Typography>
                    )} */}
                    <Typography
                    //   onClick={() => handleArticleQuesopen(user)}
                    >
                      {topic.topic}Abc test artc
                    </Typography>
                    <Typography></Typography>
                  </TableCell>

                  <TableCell>
                    <Typography> {renderStatusCount(topic, "open")}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography>
                      {renderStatusCount(topic, "pending response")}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography>
                      {renderStatusCount(topic, "replied")}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography>
                      {renderStatusCount(topic, "closed")}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography>
                      <Avatar
                        sx={{
                          fontSize: "12px",
                          background: "#2858D3",
                          display: "inline-flex",
                          border: "1px solid #FFF",
                        }}
                      >
                        {topic.totalUserCount}
                      </Avatar>
                    </Typography>
                  </TableCell>
                  {/* <TableCell>
                      <Typography>
                        {user && user.lastModifiedBy ? user.lastModifiedBy : ""}
                      </Typography>
                    </TableCell> */}

                  <TableCell>
                    <Button
                      variant="text"
                      sx={{
                        fontSize: 12,
                        color: "#2858D3",
                        fontWeight: 700,
                        marginLeft: 0,
                        padding: 0,
                      }}
                      // onClick={handleRedirectTickets}
                      onClick={() => handleRedirectTickets(topic.topic)}
                    >
                      View Tickets
                    </Button>
                    {/* <Typography
                      style={{ color: "#0157FF", cursor: "pointer" }}
                      onClick={() => handleRedirectTickets(topic.topic)}
                    >
                      View Tickets{" "}
                    </Typography> */}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
          <TableFooter>
            <TableRow></TableRow>
          </TableFooter>
        </Table>
        <TablePagination
          component="div"
          rowsPerPageOptions={[25, 50, 75, 100]}
          // count={MostReferedArticleData.total_users}
          count={MostReferedArticleData.totalCount || 0}
          rowsPerPage={rowsPerPage}
          page={page}
          SelectProps={{
            inputProps: {
              "aria-label": "rows per page",
            },
            native: true,
          }}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          ActionsComponent={TablePaginationActions}
        />
      </Box>

      {deleteOpen && (
        <DeleteDialog
          deletepopupShow={deleteOpen}
          deletepopupClose={handleDeleteClose}
          handleDeleteConfirm={deleteUser}
          type="user"
        />
      )}

      <Dialog
        className="form-container text-center"
        onClose={handleCloseResetPwDialog}
        open={openResetPwDialog}
      >
        <Box
          className={isLoading ? "form-wrap loader" : "form-wrap"}
          style={{ paddingLeft: "24px", paddingRight: "24px" }}
        >
          <DialogTitle>Reset Password</DialogTitle>
          <Typography className="info">
            Do you really want to reset password for {focusEmailId}?
          </Typography>
          <Box style={{ paddingBottom: "16px", paddingTop: "16px" }}>
            <Button variant="contained" onClick={resetPassword}>
              reset
            </Button>
            <Button
              variant="text"
              onClick={handleCloseResetPwDialog}
              style={{ marginLeft: "10px" }}
            >
              cancel
            </Button>
          </Box>
        </Box>
      </Dialog>

      <ArticleQuesopenForm
        editOpen={editOpen}
        editID={editID}
        addOpen={props.addOpen}
        setEditPopup={hadleEditPopup}
        setClosePopup={handleClosePopup}
        productLists={[]}
      />

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={alertOpen}
        autoHideDuration={2000}
        onClose={handleAlertClose}
      >
        <Alert onClose={handleAlertClose} severity="success">
          user deleted successfully !!!
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={errorAlertOpen}
        autoHideDuration={2000}
        onClose={handleErrorAlertClose}
      >
        <Alert onClose={handleErrorAlertClose} severity="error">
          Error in user delete !!!
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={alertOpenResetPw}
        autoHideDuration={2000}
        onClose={handleAlertCloseResetPw}
      >
        <Alert onClose={handleAlertCloseResetPw} severity="success">
          Password reset successfully !!!
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={errorAlertOpenResetPw}
        autoHideDuration={2000}
        onClose={handleErrorAlertCloseResetPw}
      >
        <Alert onClose={handleErrorAlertCloseResetPw} severity="error">
          Error in password reset !!!
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Manage;
